class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this.appendCapacityToTitle();

    this.addEventListener('click', this.handleClick);
  }

  appendCapacityToTitle() {
    const capacity = this.dataset.productCapacity?.trim();
    if (!capacity) return;

    const title = this.querySelector('.product-card-group h1, .product-card-group h2, .product-card-group h3, .product-card-group h4, .product-card-group h5, .product-card-group h6');
    if (!title || title.dataset.capacityApplied === 'true') return;

    const normalizedTitle = title.textContent.replace(/\s+/g, ' ').toUpperCase();
    const normalizedCapacity = capacity.replace(/\s+/g, ' ').toUpperCase();
    const capacityParts = normalizedCapacity.split('/').map((part) => part.trim());

    if (!capacityParts.every((part) => normalizedTitle.includes(part))) {
      title.append(document.createTextNode(` - ${capacity}`));
    }

    title.dataset.capacityApplied = 'true';
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
      );
      if (interactiveElement) return;
    }

    window.location.href = this.productUrl;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
